import { AlertCircle, ArrowRight, CheckCircle2, Clock3 } from 'lucide-react';
import { Button } from '../ui/button';
import WorkerPremiumCard from './WorkerPremiumCard';

const ACTION_STYLES = {
  critical: {
    card: 'border-red-200/90 bg-gradient-to-br from-red-50/90 to-white',
    iconWrap: 'bg-red-100 ring-1 ring-red-200/60',
    icon: 'text-red-600',
    badge: 'bg-red-100 text-red-800',
    button: 'bg-red-600 hover:bg-red-700 shadow-sm',
    Icon: AlertCircle,
    accent: 'amber',
  },
  high: {
    card: 'border-amber-200/90 bg-gradient-to-br from-amber-50/90 to-white',
    iconWrap: 'bg-amber-100 ring-1 ring-amber-200/60',
    icon: 'text-amber-700',
    badge: 'bg-amber-100 text-amber-800',
    button: 'bg-amber-600 hover:bg-amber-700 shadow-sm',
    Icon: Clock3,
    accent: 'amber',
  },
  medium: {
    card: 'border-primary/20 bg-gradient-to-br from-primary/[0.06] to-white',
    iconWrap: 'bg-primary/10 ring-1 ring-primary/15',
    icon: 'text-primary',
    badge: 'bg-primary/10 text-primary',
    button: 'bg-primary hover:bg-primary-hover shadow-sm',
    Icon: ArrowRight,
    accent: 'teal',
  },
  success: {
    card: 'border-green-200/90 bg-gradient-to-br from-green-50/90 to-white',
    iconWrap: 'bg-green-100 ring-1 ring-green-200/60',
    icon: 'text-green-700',
    badge: 'bg-green-100 text-green-800',
    button: 'bg-green-600 hover:bg-green-700 shadow-sm',
    Icon: CheckCircle2,
    accent: 'teal',
  },
};

export default function NextActionCard({ action, onPrimaryAction, secondaryAction }) {
  if (!action) return null;
  const style = ACTION_STYLES[action.level] || ACTION_STYLES.medium;
  const Icon = style.Icon;

  return (
    <WorkerPremiumCard
      className={`${style.card} p-0 overflow-hidden`}
      accent={style.accent}
      data-testid="next-action-card"
    >
      <div className="px-5 pt-5 pb-4">
        <div className="flex items-start gap-3.5">
          <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${style.iconWrap}`}>
            <Icon className={`h-5 w-5 ${style.icon}`} />
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-2">
              <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-primary/70">
                Next
              </p>
            </div>
            <h2 className="mt-1 font-heading text-lg font-bold text-[#17324D]">{action.title}</h2>
            <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{action.description}</p>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-2 border-t border-black/[0.04] bg-white/60 px-5 py-4 sm:flex-row">
        {action.primaryLabel ? (
          <Button
            className={`w-full sm:w-auto rounded-xl ${style.button}`}
            onClick={() => onPrimaryAction?.(action)}
          >
            {action.primaryLabel}
          </Button>
        ) : (
          <p className="text-sm text-slate-500">No action is needed from you right now.</p>
        )}
        {secondaryAction ? (
          <Button
            variant="outline"
            className="w-full sm:w-auto rounded-xl border-[#E4E8EB]"
            onClick={secondaryAction.onClick}
          >
            {secondaryAction.label}
          </Button>
        ) : null}
      </div>
    </WorkerPremiumCard>
  );
}
